export default __webpack_public_path__ + "static/media/latest-news-img18.6b51a864.jpg";